/**
 * restartGameBoot - ask a game that never reported ready to report again.
 *
 * MUS-651: the tutorial waits for the game's ready report (sent by the Empty
 * scene at the end of the boot chain: Boot, Preloader, Empty) before it loads a
 * chapter's scene or plays the video. A game that never sent it left the
 * tutorial step blank, and its Retry only started the chapter over, still
 * waiting for a report that was not coming.
 *
 * A game that reached Empty and whose report was missed sends it again when
 * Empty is restarted. Any other game runs its boot chain again from Boot: assets
 * already loaded stay in the cache, and Empty reports ready at the end.
 */

import type Phaser from 'phaser';

export const BOOT_SCENE_KEY = 'Boot';
export const READY_SCENE_KEY = 'Empty';

export function restartGameBoot(game: Phaser.Game | null | undefined): void {
  if (!game) return;
  const reachedReadyScene = game.scene.isActive(READY_SCENE_KEY);
  game.scene.start(reachedReadyScene ? READY_SCENE_KEY : BOOT_SCENE_KEY);
}
